import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "Is Unity good for app development?",
    answer: `<p>Yes, Unity simplifies cross-platform development by supporting over 25 different platforms, including Android and iOS.Moreover, mobile game development with Unity offers multi-platform capabilities to streamline deployment across various operating systems, utilizing the same code base to ensure a native feel for the game on every platform.If your app involves complex graphics, and simulations, or requires 3D elements, Unity can be an excellent choice.
    </p>`,
  },
  {
    question: " How good is Unity for game development?",
    answer: `<p>Unity is highly praised for game development due to its cross-platform capabilities, user-friendly interface, extensive asset store, and strong community support. Unity engine is great if you want to develop small games.</p>`,
  },
  {
    question: "Is Unity good for UI?",
    answer: `<p>Yes, Unity UI stands as the default choice for users requiring UI elements set and illuminated within a 3D environment.Unity's game development services elevate the creation of immersive UI elements within 3D environments, providing a comprehensive toolkit and support for seamless integration with custom shaders, materials, and easy referencing from MonoBehaviours.
    </p>`,
  },
  {
    question: "Is Unity good for Android game development?",
    answer: `<p>Yes, Unity game development stands as the industry-leading development platform, fueling more than 75% of the Android mobile games market. Its robust features and intuitive interface empower developers to create superior games tailored specifically for Android devices.With Unity's extensive toolset, optimization capabilities, and vast community, it remains the go-to choice for crafting high-quality, engaging experiences on the Android platform.</p>`,
  },
  {
    question: "How much does it cost to develop a game in Unity?",
    answer: `<p>The estimated cost of developing a game in Unity varies significantly based on the game's complexity, required features, and additional expenses.For a simple 2D game with basic mechanics, costs might range from $5,000 to $50,000 considering smaller teams and fewer assets.However, more complex 3D games with intricate gameplay, high-quality graphics, and larger development teams can cost anywhere from $100,000 to several million dollars.For the accurate cost, it’s better to consult with a reputable Unity game development company as they can provide tailored estimates based on your specific game project.</p>`,
  },

];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Unity Game Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
